import { CampaignBody, CampaignType } from "@vviinn/user-managment-client-ts";
import { filterSelectItemLabel } from "../../helpers/filterSelectItemLabel";
import { TextSearchNumbericTitles } from "../../textSearch/types";
import { CampaignNetKey } from "../../types";

export const defaultGeneralSettings: CampaignBody = {
  active: true,
};
export const defaultNotVPDSettings: CampaignBody = {
  isDefault: true,
  minimumDistance: 0,
  resultDistanceThreshold: 0,
  onlyBuyable: false,
  enabledFilterColumns: [],
  preferredImage: "first",
};

const defaultSearchFilters = ["product_type", "color", "brand", "price"];

const defaultFilterColumns = defaultSearchFilters.map((column) => {
  return {
    column: column,
    label: filterSelectItemLabel(column),
    isPrimary: false,
  };
});

export const defaultSettingsByType: Record<CampaignType, CampaignBody> = {
  VPR: {
    maximumResults: 12,
    maximumDistance: 80,
    priceWeight: 0,
    priceRelativeInflectionPoint: 30,
    categorySensitivityWeight: 0,
    priceScalingFactor: 1.15,
  },
  VPC: {
    maximumResults: 12,
    maximumDistance: 100,
    priceWeight: 0,
    priceRelativeInflectionPoint: 30,
    categorySensitivityWeight: 0,
    priceScalingFactor: 1.15,
  },
  VPS: {
    maximumResults: 24,
    maximumDistance: 80,
    useObjectDetection: true,
    objectDetector: "ginger_tea",
    gingerTeaMaximumObjects: 4,
    objectDetectionThreshold: 50,
    filterObjectByCatalogSimilarity: true,
    categoryFilterEnabled: true,
    ageGroupFilterEnabled: false,
    genderFilterEnabled: false,
    gingerTeaRelevantObjectClasses: "default",
    enabledFilterColumns: defaultFilterColumns,
  },
  VPD: {
    productAttributes: [
      "title",
      "google_product_category",
      "product_type",
      "color",
      "material",
    ],
    imageAttributes: ["image_type"],
    colorFamilyThreshold: 15,
    maximumColorFamilies: 3,
    colorThreshold: 5,
  },
  TEXT_SEARCH: {
    maximumResults: 36,
    maximumDistance: 80,
    ageGroupFilterEnabled: false,
    genderFilterEnabled: false,
    enabledFilterColumns: defaultFilterColumns,
    diversificationActive: true,
    smartRerankingActive: true,
    queryToFilterMappingActive: false,
  },
};

export type NetItem = { net: CampaignNetKey; value: number }[];

export const customNetSettingsByType: Record<
  Exclude<CampaignType, "VPD" | "TEXT_SEARCH">,
  NetItem[]
> = {
  VPR: [
    [{ net: "berryPunchWeight", value: 100 }],
    [{ net: "volcanicWaterWeight", value: 100 }],
  ],
  VPC: [
    [
      { net: "berryPunchWeight", value: 65 },
      { net: "kibaWeight", value: 35 },
    ],
    [
      { net: "berryPunchWeight", value: 65 },
      { net: "darjeelingSecondFlushWeight", value: 35 },
    ],
    [
      { net: "volcanicWaterWeight", value: 80 },
      { net: "kibaWeight", value: 20 },
    ],
    [
      { net: "volcanicWaterWeight", value: 80 },
      { net: "darjeelingSecondFlushWeight", value: 20 },
    ],
  ],
  VPS: [
    [{ net: "volcanicWaterWeight", value: 100 }],
    [{ net: "berryPunchWeight", value: 100 }],
  ],
};

export const textSearchNetsDefaults: {
  net: keyof TextSearchNumbericTitles;
  value: number;
}[][] = [
  [
    { net: "berryPunch1024", value: 65 },
    { net: "darjeeling512", value: 35 },
  ],
  [
    { net: "volcanicWater1152", value: 90 },
    { net: "darjeeling512", value: 10 },
  ],
];
